import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "CONTENT" }
const _hoisted_2 = { class: "bg-white rounded-sm shadow-sm relative" }
const _hoisted_3 = {
  id: "CONTENT-NOTE",
  class: "editor-container relative"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "flex justify-end items-center space-x-2 mx-2" }
const _hoisted_6 = {
  id: "TITLE",
  class: "flex items-center space-x-2 px-2 text-gray-500 border-white"
}
const _hoisted_7 = {
  key: 0,
  class: "text-sm text-left md:text-md font-bold"
}
const _hoisted_8 = {
  id: "DETAIL",
  class: "flex justify-start"
}
const _hoisted_9 = {
  id: "ACTION",
  class: "mt-4 flex justify-end space-x-2 p-2"
}

import { ref, nextTick, onMounted } from "vue";
import { QuillEditor } from "@vueup/vue-quill";
import { EditOutlined } from "@ant-design/icons-vue";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import i18n from "@/services/i18n";
import LearnEnglishPagePatternLayout from "../LearnEnglishPagePatternLayout.vue";
import { INote } from "@/models/INote";
import { getOneBySlug, update } from "@/api/noteApi";
import { useRoute, useRouter } from "vue-router";
import { truncateString } from "@/utils/StringUtils";
import { getRelativeTime } from "@/utils/global";
import { getLoadingPut } from "@/utils/loadingUtils";


export default /*@__PURE__*/_defineComponent({
  __name: 'NoteDetail-page',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const isEditing = ref(false);
const isEditingNoteContent = ref(false);
const titleInput = ref<HTMLInputElement | null>(null);

const noteData = ref<INote>({
  id: 0,
  title: "",
  detail: "",
  notes: "",
  user_id: 0,
  is_deleted: false,
  slug: "",
  deleted_at: null,
  created_at: "",
  updated_at: "",
  is_public: false,
});

const startEditing = () => {
  isEditing.value = true;
  nextTick(() => {
    titleInput.value?.focus();
  });
};
const handleEditContent = () => {
  isEditingNoteContent.value = !isEditingNoteContent.value;
};

const handleSave = async () => {
  try {
    const response = await update(noteData.value.id, noteData.value);
    if (response?.data) {
      noteData.value = response.data;
      updateSlug(noteData.value.slug);
    }
  } catch (err) {
    console.error(err);
  }
};
const updateSlug = (newSlug: string) => {
  router.push({ path: `/l/english/tab=notes/${newSlug}` });
};
onMounted(async () => {
  const slug = route.params.slug as string;
  if (slug) {
    try {
      const response = await getOneBySlug(slug);
      if (response?.data) {
        noteData.value = response.data;
      } else {
        router.push({ name: "NotFoundPage" });
      }
    } catch (err) {
      console.error(err);
    }
  }
});

const toolbarOptions = [
  ["bold", "italic", "underline", "strike"],
  ["blockquote", "code-block"],
  [{ header: 1 }, { header: 2 }],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }],
  [{ indent: "-1" }, { indent: "+1" }],
  [{ direction: "rtl" }],
  [{ size: ["small", false, "large", "huge"] }],
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  [{ color: [] }, { background: [] }],
  [{ font: [] }],
  [{ align: [] }],
  ["clean"],
  ["link", "image", "video"],
];

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createBlock(LearnEnglishPagePatternLayout, {
    backTo: '/l/english/tab=notes',
    title: _unref(truncateString)(noteData.value.title || '...', 30)
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (isEditingNoteContent.value)
              ? (_openBlock(), _createBlock(_unref(QuillEditor), {
                  key: 0,
                  content: noteData.value.notes,
                  "onUpdate:content": _cache[0] || (_cache[0] = ($event: any) => ((noteData.value.notes) = $event)),
                  contentType: "html",
                  toolbar: toolbarOptions,
                  theme: "snow",
                  class: "h-[500px] mb-2"
                }, null, 8, ["content"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_unref(QuillEditor), {
                    content: noteData.value.notes,
                    "onUpdate:content": _cache[1] || (_cache[1] = ($event: any) => ((noteData.value.notes) = $event)),
                    contentType: "html",
                    toolbar: toolbarOptions,
                    theme: "bubble",
                    class: "h-[500px] mb-0"
                  }, null, 8, ["content"])
                ])),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", null, _toDisplayString(_unref(getRelativeTime)(noteData.value.updated_at)), 1),
              _createVNode(_unref(EditOutlined), {
                class: "text-gray-500 hover:text-blue-500 cursor-pointer z-50",
                onClick: handleEditContent
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            (!isEditing.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(noteData.value.title || "..."), 1))
              : _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 1,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((noteData.value.title) = $event)),
                  ref_key: "titleInput",
                  ref: titleInput,
                  class: "text-sm font-bold w-[90%] px-0 py-2 dashed-border text-gray-500 rounded-sm focus:outline-none focus:ring-0 focus:ring-gray-900"
                }, null, 512)), [
                  [_vModelText, noteData.value.title]
                ]),
            _createVNode(_unref(EditOutlined), {
              class: "text-gray-500 hover:text-blue-500 cursor-pointer text-sm md:text-md flex items-center",
              onClick: startEditing
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((noteData.value.detail) = $event)),
              ref_key: "titleInput",
              ref: titleInput,
              class: "text-sm font-light w-[99%] mx-2 py-2 dashed-border text-gray-500 rounded-sm focus:outline-none focus:ring-0 focus:ring-gray-900"
            }, null, 512), [
              [_vModelText, noteData.value.detail]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_a_button, {
              loading: _unref(getLoadingPut)(),
              class: "bg-gradient-to-br from-blue-500 to-gray-600 rounded-sm",
              onClick: handleSave,
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(i18n).global.t("BUTTON_LABEL.SAVE_CHANGES")), 1)
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})